"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _CRMPropertyDateInput = _interopRequireDefault(require("customer-data-properties/date/CRMPropertyDateInput"));

var _MomentTypes = require("customer-data-properties/date/MomentTypes");

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _classnames = _interopRequireDefault(require("classnames"));

var _omit = _interopRequireDefault(require("transmute/omit"));

var _immutable = require("immutable");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _SyntheticEvent = _interopRequireDefault(require("UIComponents/core/SyntheticEvent"));

var propTypes = {
  className: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  onFocus: _react.PropTypes.func,
  property: _react.PropTypes.instanceOf(_PropertyRecord.default).isRequired,
  value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
};

var PropertyInputDate =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputDate, _React$Component);

  function PropertyInputDate() {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputDate);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputDate).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(PropertyInputDate, [{
    key: "focus",
    value: function focus() {
      return this.refs.input.focus();
    }
  }, {
    key: "handleChange",
    value: function handleChange(evt) {
      var onChange = this.props.onChange;

      if (typeof onChange !== 'function') {
        return undefined;
      }

      var originalValue = evt.target.value;
      return onChange((0, _SyntheticEvent.default)(originalValue == null ? '' : String(originalValue)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          property = _this$props.property;
      var transferableProps = (0, _omit.default)(['baseUrl', 'isInLine', 'getProperty', 'MomentType', 'objectType', 'onCancel', 'onInvalidProperty', 'propertyIndex', 'readOnlySourceData', 'resolver', 'showError', 'subject', 'subjectId', 'unstyled', 'secondaryChanges', 'onSecondaryChange', 'onTracking', 'isRequired'], (0, _immutable.Seq)(this.props)).toJS();
      return _react.default.createElement(_CRMPropertyDateInput.default, (0, _extends2.default)({}, transferableProps, {
        className: (0, _classnames.default)('hs-pickadate', className),
        momentType: _MomentTypes.MomentTypes.USER,
        onChange: this.handleChange,
        ref: "input",
        type: property.type
      }));
    }
  }]);
  return PropertyInputDate;
}(_react.default.Component);

exports.default = PropertyInputDate;
PropertyInputDate.propTypes = propTypes;
module.exports = exports.default;